function getShape(arr) {
  const shape = [];
  while (Array.isArray(arr)) {
    shape.push(arr.length);
    arr = arr[0];
  }
  return shape;
}

function getElement(arr, indices) {
  for (let i = 0; i < indices.length; i++) {
    arr = arr[indices[i]];
  }
  return arr;
}

function setElement(arr, indices, value) {
  for (let i = 0; i < indices.length - 1; i++) {
    arr = arr[indices[i]];
  }
  arr[indices[indices.length - 1]] = value;
}

function createArray(shape) {
  if (shape.length === 0) return undefined;
  const size = shape[0];
  const rest = shape.slice(1);
  const arr = new Array(size);
  for (let i = 0; i < size; i++) {
    arr[i] = rest.length > 0 ? createArray(rest) : undefined;
  }
  return arr;
}

function* generateIndices(shape) {
  if (shape.length === 0) {
    yield [];
  } else {
    for (let i = 0; i < shape[0]; i++) {
      for (const sub of generateIndices(shape.slice(1))) {
        yield [i, ...sub];
      }
    }
  }
}

export default function pivotAxes(arr, permutation) {
  const shape = getShape(arr);
  if (permutation.length !== shape.length) {
    throw new Error("Permutation must match array dimension.");
  }

  const newShape = permutation.map(i => shape[i]);
  const result = createArray(newShape);

  for (const idx of generateIndices(shape)) {
    const newIdx = permutation.map(i => idx[i]);
    setElement(result, newIdx, getElement(arr, idx));
  }

  return result;
}

export function computePermutation(original, permuted) {
  if (original.length !== permuted.length) {
    throw new Error("Arrays must have the same length");
  }

  const indexMap = new Map();
  original.forEach((val, i) => {
    if (!indexMap.has(val)) indexMap.set(val, []);
    indexMap.get(val).push(i);
  });

  const perm = [];
  for (const val of permuted) {
    const indices = indexMap.get(val);
    if (!indices || indices.length === 0) {
      throw new Error(`Value ${val} not found in original`);
    }
    perm.push(indices.shift());
  }

  return perm;
}

